import { render, staticRenderFns } from "./GlossaryItem.vue?vue&type=template&id=4fcbcae6&scoped=true&"
import script from "./GlossaryItem.vue?vue&type=script&lang=js&"
export * from "./GlossaryItem.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryItem.vue?vue&type=style&index=0&id=4fcbcae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbcae6",
  null
  
)

export default component.exports